import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SelectBoxSearch from "../../../../shared/components/select_box_search";
import { formatDate } from "../../../../shared/util/functions";
import { gerenciaTecnicaSlice, selectGtoState, selectMainState, useDispatch } from "../../../../stateManagement/redux";
import { getReportsList } from "../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { Project, ReportInterface } from "../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces";
import { ModalReportViewer } from "../../../modules/reports_viewer/reportsViewer";
import "./styles.scss";
import { formatDateToYYYYMMDD } from "src/shared/util/formatDates";
import { RoutesWeb } from "src/shared/interfaces/routes";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import DatePicker from "react-datepicker";
import { ProjectList } from "src/stateManagement/redux/slices/shared/interfaces";


const Dashboards = () => {
    const navigate = useNavigate();
    const options: string[] = ["Nombre", "Codigo"];

    const dispatch = useDispatch();

    const { configModules } = useSelector(selectMainState);

    const [selectedOption, setSelectedOption] = useState(options[0]);

    // const [activeReport, setActiveReport] = useState<ReportInterface>();

    const [inputValueFilter, setInputValueFilter] = useState<string>("");

    const [listOfReports, setListOfReports] = useState<ReportInterface[]>([]);

    const mainState = useSelector(selectGtoState);

    const [projectList, setprojectList] = useState<ProjectList[]>([])

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [projectId, setProjectId] = useState("");

    const onClickSetActiveReport = (report: ReportInterface) => {
        dispatch(gerenciaTecnicaSlice.actions.setReportFilter({ startDate: formatDateToYYYYMMDD(startDate), endDate: formatDateToYYYYMMDD(endDate), projectId, activeReport: report }));

        if (report.name === "Consolidado Campo BCP") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_consolidate_bcp);
        }else if (report.name === "Consolidado Campo BM") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_consolidate_bm);
        }else if (report.name === "Cartas BM") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_consolidate_cards_bm);
        }else if (report.name === "Cierre Dia") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_close_daily);
        }else if (report.name === "Resumen Diario Tierra") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_daily_summary);
        }else if (report.name === "Relacion de Analisis y Requerimientos") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.analyst_summary);
        }else {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_consolidate_bcp);
        }
    };

    useEffect(() => {
        console.log({configModules})
        if (configModules?.projectList){
            setprojectList(configModules?.projectList);
        }

    }, [configModules])
    

    useEffect(() => {
        if (mainState?.reportsList?.length === 0) {
            dispatch(getReportsList());
        }
    }, []);

    useEffect(() => {
        let reports = mainState.reportsList;

        if (!Array.isArray(reports) || reports.length === 0) return;

        reports = reports?.map((report) => {
            return {
                id: report.id,
                code: report.code,
                name: report.name,
                description: report.description,
                department: report.department,
                version: report.version,
                config: report.config,
                updated: report.releaseDate
                    ? formatDate(report.releaseDate, "dd-MMM-yyyy")
                    : "pendiente",
                type: report.type,
            };
        });

        if (inputValueFilter === "") {
            setListOfReports(reports);
        } else if (selectedOption === "Nombre") {
            setListOfReports(
                reports.filter((report) =>
                    report.name
                        .toLowerCase()
                        .includes(inputValueFilter.toLowerCase())
                )
            );
        } else if (selectedOption === "Codigo") {
            setListOfReports(
                reports.filter((report) =>
                    report.code
                        .toLowerCase()
                        .includes(inputValueFilter.toLowerCase())
                )
            );
        }
    }, [inputValueFilter, mainState.reportsList]);

    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueFilter(event.target.value);
    };

    const onCloseReport = () => {
        // setActiveReport(undefined);
        dispatch(gerenciaTecnicaSlice.actions.emptyReportData());
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid
                    size={12}
                    className="dashboard_container_filter_container"
                >
                    <Grid size={4}>
                        <label className="dashboard_container_label">
                            Fecha Inicio
                        </label>
                        <DatePicker
                            selected={startDate}
                            onChange={(date: Date | null) =>
                                setStartDate(date || new Date())
                            }
                            dateFormat="yyyy/MM/dd"
                        />
                    </Grid>
                    <Grid size={4}>
                        <label className="dashboard_container_label">
                            Fecha Fin
                        </label>
                        <DatePicker
                            selected={endDate}
                            onChange={(date: Date | null) =>
                                setEndDate(date || new Date())
                            }
                            dateFormat="yyyy/MM/dd"
                        />
                    </Grid>
                    <Grid size={4}>
                        <FormControl fullWidth>
                            <InputLabel
                                id="demo-simple-select-label"
                                size="small"
                            >
                                Proyecto
                            </InputLabel>
                            <Select
                                size="small"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={projectId}
                                label="Proyecto"
                                onChange={(e) =>
                                    setProjectId(e.target.value)
                                }
                            >
                                {projectList.map((f, index) => (
                                    <MenuItem
                                        key={index}
                                        value={f.projectId}
                                    >
                                        {" "}
                                        {f.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid size={6} sx={{ mt: 2 }}>
                    <SelectBoxSearch
                        options={options}
                        selectedOption={selectedOption}
                        onOptionChangeSelectBox={handleSelectChange}
                        onValueChangeInput={handleFilterInput}
                        inputValue={inputValueFilter}
                    />
                </Grid>
                <Grid size={12} className="table_reports_dashboards">
                    <div className="header">
                        <div>Code</div>
                        <div>Nombre</div>
                        <div>Descripcion</div>
                        <div>Departamento</div>
                        <div>Version</div>
                        <div>Updated</div>
                    </div>
                    <div className="_body_row">
                        {listOfReports.map((report, index) => (
                            <div
                                key={index}
                                className="body_row"
                                onClick={() => onClickSetActiveReport(report)}
                            >
                                <div>{report.code}</div>
                                <div>{report.name}</div>
                                <div>{report.description}</div>
                                <div>{report.department}</div>
                                <div>{report.version}</div>
                                <div>{report.updated}</div>
                            </div>
                        ))}
                    </div>
                </Grid>
            </Grid>
        </>
    );
};

export default Dashboards;
